if (!RedactorPlugins) var RedactorPlugins = {};

RedactorPlugins.fontcolor = function(){
    return {
        init: function(){
            var buttons = ['fontcolor', 'backcolor'],
               self = this;
       
            for (var i = 0; i < buttons.length; i++){
                var name = buttons[i],
                    button = this.button.add(name, this.lang.get(name)); 
            
                    var input = $("<input class='colorpicker-input' rel='"+buttons[i]+"' type='text'>");
                    input.insertAfter(button);                   
                    
                    input.colorpicker({
                        "open": function(event){
                            //prevent http://bt.web100.com.ua/view.php?id=4932
                            self.$editor.on('keydown.dialog', function(){                                
                                return false;
                            });

                            $(event.target).siblings("a").addClass("redactor-act");
                        },
                        "ok": function(event, data){
                            var rule = ($(this).attr("rel") === 'backcolor') ? 'background-color' : 'color';
                            self.inline.format('span', 'style', rule + ': ' + data.formatted + ';');
                        },
                        "close": function(){
                            self.$editor.off('keydown.dialog');
                            self.dropdown.hideAll();
                            self.button.setInactiveAll();
                        }
                    });
                    
                    button.off('click').on('click',function(){
                        self.dropdown.hideAll();
                        self.button.setInactiveAll();                        
                        var input = $(this).siblings("input");
                        setTimeout(function(){                 
                            input.colorpicker("open");
                        },10);
                    });                
            }
        },
        remove: function(rule)
        {
            this.inline.removeStyleRule(rule);
        }
    };
};